export type FormValues = {
  name: string
  email: string
  company: string
  role: string
  serviceInterest: string
  currentCrm: string
  connectedTools: string
  projectGoals: string
  painPoints: string
  dataOrigin: string
  dataDestination: string
  stakeholders: string
  timeline: string
  budget: string
  additionalContext: string
  consent: boolean
}

export type FormErrors = Partial<Record<keyof FormValues, string>>
export type UpdateDiscoveryField = <K extends keyof FormValues>(
  field: K,
  value: FormValues[K],
) => void

export const initialValues: FormValues = {
  name: '',
  email: '',
  company: '',
  role: '',
  serviceInterest: '',
  currentCrm: '',
  connectedTools: '',
  projectGoals: '',
  painPoints: '',
  dataOrigin: '',
  dataDestination: '',
  stakeholders: '',
  timeline: '',
  budget: '',
  additionalContext: '',
  consent: false,
}

export function validateDiscovery(values: FormValues): FormErrors {
  const errors: FormErrors = {}
  const requiredFields: Array<keyof FormValues> = [
    'name',
    'email',
    'company',
    'role',
    'serviceInterest',
    'currentCrm',
    'connectedTools',
    'projectGoals',
    'painPoints',
    'dataOrigin',
    'dataDestination',
    'stakeholders',
    'timeline',
  ]

  requiredFields.forEach((field) => {
    const value = values[field]
    if (typeof value === 'string' && !value.trim())
      errors[field] = 'This field is required.'
  })
  if (values.email && !/^\S+@\S+\.\S+$/.test(values.email))
    errors.email = 'Enter a valid work email address.'
  if (!values.consent)
    errors.consent = 'Please confirm that Daanish can respond to this enquiry.'
  return errors
}

export function createDiscoveryMailto(values: FormValues) {
  const sections = [
    [
      'CONTACT',
      `Name: ${values.name}`,
      `Work email: ${values.email}`,
      `Company: ${values.company}`,
      `Role: ${values.role}`,
    ],
    [
      'PROJECT',
      `Service interest: ${values.serviceInterest}`,
      `Timeline: ${values.timeline}`,
      `Budget range: ${values.budget || 'Not provided'}`,
      '',
      'Goals:',
      values.projectGoals,
      '',
      'Pain points:',
      values.painPoints,
    ],
    [
      'SYSTEM CONTEXT',
      `Current CRM: ${values.currentCrm}`,
      '',
      'Connected tools:',
      values.connectedTools,
      '',
      'Data originates in:',
      values.dataOrigin,
      '',
      'Data should end up in:',
      values.dataDestination,
    ],
    [
      'PEOPLE & NOTES',
      `Teams / stakeholders: ${values.stakeholders}`,
      '',
      'Additional context:',
      values.additionalContext || 'Not provided',
    ],
  ]
  const body = sections
    .map((section) => section.join('\n'))
    .join('\n\n────────────────────\n\n')
  return `mailto:hello@daanish.co?subject=${encodeURIComponent(`CRM discovery enquiry — ${values.company}`)}&body=${encodeURIComponent(body)}`
}
